import { camelCase } from "lodash-es";

/**
 *
 * @param title
 * @param keySuffix
 * @param valueSuffix
 * @returns {{rowDataAid: *, valueDataAid: string, title: {dataAid: string, text:title}}}
 */
const getRowObject = ({title, titleDataAid = 'key', valueSuffix = 'value'}) => ({
    rowDataAid: camelCase(title),
    key: {
        text: title,
        dataAid: titleDataAid,
    },
    value:{text: valueSuffix},
});


const PERSONAL_INFO = {
    title: {
        text: 'Personal information',
        dataAid: 'personalInformation',
    },

        panRow: {
            ...getRowObject({title:"PAN"}),
        },
        nameRow: {
            ...getRowObject({title:'Name'}),
        },
        mobileNumberRow: {
            ...getRowObject({title:'Mobile number'}),
            actionBtn: {
                dataAid: 'link',
                text: 'Verify now',
            },
        },
        emailRow: {
            ...getRowObject({title:'Email'}),
            actionBtn: {
                dataAid: 'link',
                text: 'Verify now',
            },
        },
        taxStatus: {
            ...getRowObject({title:'Tax status'}),
        },

};

const DEMAT_ACCOUNT = {
    title: {
        text: 'Trading & Demat account ',
        dataAid: 'dematAccountList',
    },
    uniqueClientCode: {
        ...getRowObject({title:'Unique client code'}),
        copyIconDataAid: 'uniqueClient'
    },
    boId: {
        ...getRowObject({title:'BO ID'}),
        infoIconDataAid: 'bo',
        tooltip: {
            text:"This is a 16-digit number used to identify your Demat account",
            dataAid: 'dematAccount'
        },
        copyIconDataAid: 'boId'
    },
    dpId: {
        ...getRowObject({title:'DP ID'}),
        infoIconDataAid: 'dp',
        tooltip: {
            text: 'This is a 8-digit identification number of the Depository Participant ',
            dataAid: 'dematAccount'
        },
        copyIconDataAid:'dbId'
    },
    depositoryName: {
        ...getRowObject({title:'Depository name'}),
    },
    depositoryParticipant: {
        ...getRowObject({title:'Depository participant'}),
    },
};

const NOMINEE_CARD = {
    title: {
        text: 'Nominee details',
        dataAid: "title"
    },
    rowDataAid: 'nominee',
};

const ACCOUNT_RELATED_FORM_CARD = {
    title: {
        text: 'Account related forms',
        dataAid: "title"
    },
    rowDataAid: 'accountForms',
};

const CLOSE_DEMAT_ACCOUNT_CARD = {
    title: {
        text: 'Close Trading & Demat account',
        dataAid: "title"
    },
    rowDataAid: 'closeDemat',
};

const MISCELLANEOUS = {
    title: {
        text: 'Account details',
        dataAid: 'accountDetails',
    },
    pageDataAid: "accountDetails",
    backIconDataAid: 'left',
    codeCopyToast: {
        text: "Code copied"
    }
}
const OTP_BOTTOM_SHEET = {
    title: {
        text: 'Enter OTP',
        dataAid:'title'
    },
    subtitle: {
        text: (email) =>`OTP sent to ${email}`,
        dataAid:'subtitle'
    },
    helperText: {
        text: 'Incorrect OTP',
        dataAid: 'helperText'
    },
    otpTimer: {
        text: 'Didn’t receive OTP?',
        dataAid: 'otpTime'
    },
    resendBtn: {
        text: 'RESEND',
    },
    submitOtp: {
        text: 'Submit OTP'
    }
}
const BOTTOM_SHEET = {
    bottomSheetDataAid: 'verification',
    title: {
        text: "Account already exists!",
        dataAid: 'title'
    },
    subtitleMobile: {
        title: {
            text: "Your mobile number is already registered with",
            dataAid: 'subtitle'
        },
        actionBtn: {
            text: 'EDIT NUMBER'
        },
        emailSub:(email,pan) => `Email: ${email} | PAN: ${pan}`,
    },
    subtitleEmail: {
        title: {
            text: "Your email is already registered with",
            dataAid: 'subtitle'
        },
        actionBtn: {
            text:'EDIT EMAIL'
        },
        mobilNumberText: (number,pan) => `Mobile number: ${number} | PAN: ${pan}`

    },
}


export const MY_ACCOUNT_DETAIL = {
    ...MISCELLANEOUS,
    PERSONAL_INFO,
    DEMAT_ACCOUNT,
    NOMINEE_CARD,
    ACCOUNT_RELATED_FORM_CARD,
    CLOSE_DEMAT_ACCOUNT_CARD,
    BOTTOM_SHEET,
    OTP_BOTTOM_SHEET
};

export default  MY_ACCOUNT_DETAIL;
